import React, { useState, useEffect } from 'react'
import { CreateUrl, CallGetAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import Loader from '../../Utils/Loader/NewLoader2025'
import { APIImageUpload, buildAPIImageUpload } from "models/APIImageUpload";
import { useMobileLandscape } from '../../Context/ContextProvider'
import { primaryColor } from '../../assets/jss/material-dashboard-react';
import ImageOverlayMobile from './ImageOverlayMobile'
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
interface Props {
    siteId: number | null | undefined
    loggerId: number | null | undefined
    chariotId: number | null | undefined
}

interface ItemDisplayData {
    src: string
    caption: string
    id: string
    azure: boolean
    fileName: string | null
    type: string
}

const MobileImagePanel: React.FC<Props> = ({ siteId, loggerId, chariotId }) => {

    const isLandscape = useMobileLandscape()

    useEffect(() => {
        reloadData()
    }, [])
    


    const [loading, setLoading] = useState<boolean>(true)
    //const [imageURLs, setImageURLs] = useState<Array<string>>([])
    const [images, setImages] = useState<ItemDisplayData[]>()
    const [pdfs, setPdfs] = useState<ItemDisplayData[]>()
    const [modal, setModal] = useState<boolean>(false)
    const [overlayItem, setOverlayItem] = useState<ItemDisplayData>()
    const [hoveredIndex, setHoveredIndex] = useState<null | number>(null);

    useEffect(() => {
        if (modal) {
            document.documentElement.style.overflow = 'hidden'
        } else {
            document.documentElement.style.overflow = 'auto'
        }
    }, [modal])

    const reloadData = (): void => {
        const imagesData: ItemDisplayData[] = [];
        const pdfData: ItemDisplayData[] = []
        CallGetAPI(CreateUrl('/api/aquaguard/Images?siteId=' + (siteId ? siteId : 0)
            + "&loggerId=" + (loggerId ? loggerId : 0)
            + "&chariotId=" + (chariotId ? (chariotId > 500000 ? chariotId - 500000 : chariotId) : 0)
        ), {})
            .then(response => {
                for (let i = 0; i < response.length; i++) {
                    console.log(response[i])
                    const data = (buildAPIImageUpload(response[i], null));
                    console.log(data)
                    if (data.ContentType !== 'application/pdf') {
                        let useAzure = false;
                        let imageTemp: ItemDisplayData = { src: '', caption: '', id: '', azure: false, fileName: null, type: '' }
                        if (data.Id.toString() == "00000000-0000-0000-0000-000000000000") {
                            useAzure = true;
                        }
                        if (useAzure == true) {
                            imageTemp = {
                                src: data.Filename,
                                caption: data.Caption ? data.Caption : '',
                                id: data.Id,
                                azure: true,
                                fileName: data.Filename,
                                type: 'image / jpeg'
                            }
                        }
                        else {
                            imageTemp = {
                                src: CreateUrl('/api/aquaguard/Images/' + data.Id.toString()),
                                caption: data.Caption ? data.Caption : '',
                                id: data.Id,
                                azure: false,
                                fileName: data.Filename ? data.Filename : null,
                                type: 'image / jpeg'
                            }
                        }
                        imagesData.push(imageTemp)
                    } else if (data.ContentType === "application/pdf") {
                        let useAzure = false;
                        let pdfTemp: ItemDisplayData = { src: '', caption: '', id: '', azure: false, fileName: null, type: '' }
                        if (data.Id.toString() == "00000000-0000-0000-0000-000000000000") {
                            useAzure = true;
                        }
                        if (useAzure == true) {
                            pdfTemp = {
                                src: data.Filename,
                                caption: data.Caption ? data.Caption : '',
                                id: data.Id,
                                azure: true,
                                fileName: data.Filename,
                                type: 'application / pdf'
                            }
                        } else {
                            pdfTemp = {
                                src: CreateUrl('/api/aquaguard/Images/' + data.Id),
                                caption: data.Caption ? data.Caption : '',
                                id: data.Id,
                                azure: false,
                                fileName: data.Filename ? data.Filename : null,
                                type: 'application / pdf'
                            }
                        }
                        pdfData.push(pdfTemp)
                    }
                }
                setTimeout(() => {
                    setLoading(false)
                    setImages(imagesData)
                    setPdfs(pdfData)
                }, 1000)

            })
            .catch(function (ex) {
                setLoading(false)
                setImages([])
                setPdfs([])
                console.error(ex);
            });
    }

    const handleItemClick = (src: string, type: string): void => {
        if (type == 'img') {
            const clickedImage = images?.find(img => img.src === src)
            setOverlayItem(clickedImage)
        } else if (type === 'pdf') {           
            const clickedPdf = pdfs?.find(pdf => pdf.src === src)
            setOverlayItem(clickedPdf)
        }
        setModal(true)
    }


    
    return (
        <div>
            {modal && <ImageOverlayMobile handleClose={(): void => setModal(false)} item={overlayItem} reloadData={reloadData} />}
            {loading && <div style={{
                position: 'relative', left: 'Calc(50% - 100px)', height: 250
            }}>
                <Loader color={undefined} />
            </div>}
            {!loading &&
                <div style={{ display: "flex", justifyContent: "center", width: "100%", transform: isLandscape ? "0" : "30px" }}>
                    <div style={{ display: isLandscape ? 'flex' : 'block', flexWrap: 'wrap' }} >
                        {images && images.length > 0 && images.map((img: ItemDisplayData, idx: number) => {
                            return (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                        margin: "20px 0",
                                        position: 'relative'
                                    }}>
                                    <img
                                        src={img.src}
                                        style={{
                                            width: isLandscape
                                                ? "30%"
                                                : "90%",
                                            borderRadius: 5,
                                            boxShadow: "3px 3px 6px gray",
                                            minWidth: isLandscape
                                                ? "400px"
                                                : 'none'
                                        }}
                                        onClick={():void => handleItemClick(img.src, 'img') }
                                    />
                                    {img.caption && <div
                                        style={{
                                            backgroundColor: primaryColor[0],
                                            width: isLandscape
                                                ? "30%"
                                                : "90%",
                                            position: 'absolute',
                                            bottom: 0,
                                            borderBottomLeftRadius: 5,
                                            borderBottomRightRadius: 5
                                        }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#f4f4f4' }}>
                                            {img.caption}
                                        </p>
                                    </div>}
                                </div>
                            )
                        })}
                        {pdfs && pdfs.length > 0 && pdfs.map((pdf: ItemDisplayData, idx: number) => {
                            return (
                                <div
                                    onClick={():void => handleItemClick(pdf.src, 'pdf')}
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%',
                                        position: 'relative'
                                    }}
                                >
                                    <iframe
                                        
                                        style={{
                                            border: "none",
                                            marginTop: "2px",
                                            width: isLandscape
                                                ? "30%"
                                                : "90%",
                                            height: "15em",
                                            borderRadius: 5,
                                            boxShadow: "3px 3px 6px gray",
                                            pointerEvents: 'none'
                                        }}
                                        src={`${pdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                                        
                                    />
                                    {pdf.caption && <div
                                        style={{
                                            backgroundColor: primaryColor[0],
                                            width: isLandscape
                                                ? "30%"
                                                : "90%",
                                            position: 'absolute',
                                            bottom: 0,
                                            borderBottomLeftRadius: 5,
                                            borderBottomRightRadius: 5
                                        }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#f4f4f4' }}>
                                            {pdf.caption}
                                        </p>
                                    </div>}
                                   
                                </div>
                            )
                        })}
                        {images && images.length === 0 && 
                            <p style={{marginTop: "20px"} }><FormattedMessage id='No images uploaded'/></p>
                        }
                    </div>
                </div>
            }
        </div>
    )
}
export default MobileImagePanel